import { OnInit, Component, Inject, Optional } from '@angular/core';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { PershingTranslationService } from '@pershing/pershing-core';
@Component({
    selector: 'site-terms-conditions-component',
    templateUrl: './terms-conditions-component.html'
})

export class TermsConditionsComponent implements OnInit {
    disagreeButton: string;
    agreeButton: string;
    communityName: string;
    ibd: string;
    isAdaptive: boolean = false;
    showError: boolean = false;
    redirectUrl: string;
    landingPage: string = 'default';

    constructor(
        private nxiRestService: NxiRestService,
        private translationService: PershingTranslationService,
        @Optional() @Inject('AppSettings') appSettings: any) {
            this.ibd = appSettings.ibdConfigMap.IBD;
            this.communityName = appSettings.ibdConfigMap.community;
            if (appSettings.deviceType && appSettings.deviceType !== 'desktop') {
                 this.isAdaptive = true;
                }
            this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    ngOnInit() {
        let lpParam = this.getQueryString('lp');
        if (lpParam) {
            this.landingPage = lpParam;
        }
        this.translationService.get('TERMSCONDITIONS.' + this.ibd + '.DISAGREE').subscribe(
            result => {
                if (result && !result.includes('TERMSCONDITIONS')) {
                     this.disagreeButton = result;
                    } else  {
                        if (!this.disagreeButton) {
                            this.translationService.get('TERMSCONDITIONS.DISAGREE').subscribe(
                                resp => {
                                    this.disagreeButton = resp;
                                });
                            }
                        }
                    });
        this.translationService.get('TERMSCONDITIONS.' + this.ibd + '.AGREE').subscribe(
            result => {
                if (result && !result.includes('TERMSCONDITIONS')) {
                    this.agreeButton = result;
                } else  {
                    if (!this.agreeButton) {
                        this.translationService.get('TERMSCONDITIONS.AGREE').subscribe(
                            resp => {
                                this.agreeButton = resp;
                            });
                }
        }
            });
    }

    preventDoubleClick(event: any, type: string) {
        let formSubmitted = false;
        if (!formSubmitted) {
            formSubmitted = true;
        } else {
            // disable event propagation if form is already submitted
            if (event.preventDefault) {
                event.preventDefault();
            }
            event.returnValue = false;
        }
        if (type === 'cancelAgreement') {
            document.dispatchEvent(new CustomEvent('portal.gotoview', {
                detail: {
                    'gotoPage': '/nxi/site-terms-and-conditions-declined'
                }
            }));
        } else {
            this.submitAgreement();
        }
    }

    submitAgreement() {
        this.nxiRestService.getNxiPortfolioRestUrlResponse('submitAgreement').subscribe(
            resp => {
                if (resp.response && resp.response.returnCode === 0) {
                    this.redirectUrl = '/nxi/redirectLandingPage?landingPage=' + this.landingPage;
                    location.href = this.redirectUrl;
                } else {
                    this.showError = true;
                }
            }
        );
    }

     // To get the value from queryparam in the url
     getQueryString(name: string): string {
        let regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
            results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

}
